import styled from "styled-components";
import theme from "./../../images/background.webp";

export const StyledHome = styled.section`
  background-image: linear-gradient(to bottom, #00000010 100%, #00000000),
    url(${theme});
`;
